document.addEventListener('DOMContentLoaded', () => {
  initRevealOnScroll();
  initGaleriaProducto();
  initVariantesProducto();
});

function initRevealOnScroll() {
  const elementos = document.querySelectorAll('.rs-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach((el) => el.classList.add('rs-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('rs-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  elementos.forEach((el) => observer.observe(el));
}

function initGaleriaProducto() {
  const galeria = document.querySelector('[data-rs-galeria]');
  if (!galeria) return;

  const pista = galeria.querySelector('[data-rs-pista]');
  const slides = [...galeria.querySelectorAll('[data-rs-slide]')];
  const puntos = galeria.querySelectorAll('[data-rs-punto]');
  const flechaPrev = galeria.querySelector('[data-rs-flecha="prev"]');
  const flechaSiguiente = galeria.querySelector('[data-rs-flecha="siguiente"]');
  if (!pista || !slides.length) return;

  let indiceActual = 0;

  function irA(indice) {
    const destino = Math.max(0, Math.min(indice, slides.length - 1));
    slides[destino].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  puntos.forEach((punto, index) => {
    punto.addEventListener('click', () => irA(index));
  });

  if (flechaPrev) {
    flechaPrev.disabled = true;
    flechaPrev.addEventListener('click', () => irA(indiceActual - 1));
  }
  if (flechaSiguiente) flechaSiguiente.addEventListener('click', () => irA(indiceActual + 1));

  if (!puntos.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = slides.indexOf(entry.target);
          indiceActual = index;
          puntos.forEach((p) => p.classList.remove('is-active'));
          if (puntos[index]) puntos[index].classList.add('is-active');
          if (flechaPrev) flechaPrev.disabled = index === 0;
          if (flechaSiguiente) flechaSiguiente.disabled = index === slides.length - 1;
        }
      });
    },
    { root: pista, threshold: 0.6 }
  );

  slides.forEach((slide) => observer.observe(slide));
}

function initVariantesProducto() {
  const forms = document.querySelectorAll('[data-rs-producto-form]');
  forms.forEach((form) => {
    const dataEl = form.querySelector('[data-rs-variantes-json]');
    if (!dataEl) return;

    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const contenedor = form.closest('.rs-producto__info') || form;
    const botones = form.querySelectorAll('[data-rs-valor-opcion]');
    const idInput = form.querySelector('input[name="id"]');
    const precioEl = contenedor.querySelector('[data-rs-precio]');
    const precioComparadoEl = contenedor.querySelector('[data-rs-precio-comparado]');
    const ahorroEl = contenedor.querySelector('[data-rs-ahorro]');
    const submitBtn = form.querySelector('[data-rs-agregar]');
    if (!botones.length) return;

    const seleccion = {};
    botones.forEach((btn) => {
      if (btn.classList.contains('is-selected')) {
        seleccion[btn.dataset.rsOpcionNombre] = btn.dataset.rsValorOpcion;
      }
    });

    function actualizar() {
      const variante = variantes.find((v) =>
        v.options.every((valor, i) => seleccion[`opcion_${i + 1}`] === valor)
      );
      if (!variante) return;

      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_formatted;

      if (precioComparadoEl) {
        if (variante.compare_at_price_formatted) {
          precioComparadoEl.textContent = variante.compare_at_price_formatted;
          precioComparadoEl.hidden = false;
        } else {
          precioComparadoEl.hidden = true;
        }
      }

      if (ahorroEl) {
        if (variante.ahorro_formatted) {
          ahorroEl.textContent = 'Ahorrás ' + variante.ahorro_formatted + ' frente a comprar por separado';
          ahorroEl.hidden = false;
        } else {
          ahorroEl.hidden = true;
        }
      }

      if (submitBtn) {
        if (variante.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.textoDisponible;
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.dataset.textoAgotado;
        }
      }
    }

    botones.forEach((btn) => {
      btn.addEventListener('click', () => {
        const grupo = btn.dataset.rsOpcionNombre;
        seleccion[grupo] = btn.dataset.rsValorOpcion;

        form.querySelectorAll(`[data-rs-opcion-nombre="${grupo}"]`).forEach((b) => {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        actualizar();
      });
    });
  });
}
